"use client";

import React from "react";
import { graphql, PageProps } from "gatsby";
import { Helmet } from "react-helmet";
import { Event } from "@app/components/event/Event";
import { EventPage } from "@app/models";

type Props = {
  related: {
    edges: {
      node: EventPage;
    }[];
  };
  storyblokEntry: {
    content: string;
    date: string;
    eventId: string;
    title: string;
    subtitle: string;
    summary: string;
    image: string;
    btn1: string;
    btn2: string;
    isIndexingDisabled?: boolean;
  };
};

const EventPageTemplate: React.FC<PageProps<Props>> = ({
  data: { storyblokEntry },
}) => {
  return (
    <>
      {storyblokEntry.isIndexingDisabled && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
      <Event {...storyblokEntry} />
    </>
  );
};

export default EventPageTemplate;

export const query = graphql`
  query ($fullSlug: String!, $language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    storyblokEntry(full_slug: { eq: $fullSlug }) {
      date: field_date_string
      eventId: field_eventId_string
      title: field_title_string
      subtitle: field_subtitle_string
      summary: field_summary_string
      image: field_image_string
      btn1: field_primaryButton_text_string
      btn2: field_secondaryButton_text_string
      content
      isIndexingDisabled: field_isIndexingDisabled_boolean
    }
  }
`;
